"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAlcohol = createAlcohol;
const alcohol_1 = require("../../../forms/basic-health/risks/alcohol");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    alcohol: {
        id: "dashboard.alcohol",
        defaultMessage: "Alkohol fogyasztás"
    },
    currentAlcoholUse: {
        id: "dashboard.alcohol.current_alcohol_use",
        defaultMessage: "Aktuálisan fogyaszt alkoholt"
    },
    currentAlcoholAbuse: {
        id: "dashboard.alcohol.current_alcohol_abuse",
        defaultMessage: "Aktuálisan alkoholfüggőség gyanúja felmerül"
    },
    anamnesticAlcoholAbuse: {
        id: "dashboard.alcohol.anamnestic_alcohol_abuse",
        defaultMessage: "Anamnézisében szerepel alkoholfüggőség"
    }
};
const values = [
    {
        type: "formatted-message",
        label: messages.currentAlcoholUse,
        query: queries_1.queries.currentAlcoholUse,
        messages: alcohol_1.currentAlcoholUseMessages
    },
    {
        type: "formatted-message",
        label: messages.currentAlcoholAbuse,
        query: queries_1.queries.currentAlcoholAbuse,
        messages: shared_1.yesNoMessages
    },
    {
        type: "formatted-message",
        label: messages.anamnesticAlcoholAbuse,
        query: queries_1.queries.anamnesticAlcoholAbuse,
        messages: shared_1.yesNoMessages
    }
];
function createAlcohol(intl, { events }) {
    return (0, shared_1.createMixedList)(intl, { events, label: messages.alcohol, values });
}
